var _a;
import * as radio from '@zag-js/radio-group';
import { createContext } from '../../internal/create-context.js';
export var setSegmentContext = (_a = createContext({
    api: {},
    indicatorText: ''
}), _a[0]), getSegmentContext = _a[1], key = _a[2];
